import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import GridElement from '../../Common/GridElement';
import {getBookkeeperImportHistory} from "../../../API/bookkeeper";

const IMPORT_COLUMNS = [
    { key: 'import_id', label: 'Import ID', sortable: false },
    { key: 'import_file_name', label: 'File Name', sortable: false },
    { key: 'import_status', label: 'Status', sortable: false },
    { key: 'import_errors', label: 'Errors', sortable: false },
    {
        key: 'created_by',
        label: 'User',
        sortable: false,
        accessor: (row) => row.created_by?.user_firstname+' '+row.created_by?.user_lastname || '',
    },
    { key: 'created_at', label: 'Created At', sortable: false },
];

const makeHeader = (title) => title.replace(/_/g, ' ');
const makeAccessor = (key, accessor) => accessor || key;

const parseRow = (raw) => {
    const item = { ...raw };
    item.id = item.import_id;
    return item;
};

const BookkeeperImportHistory = () => {
    const [cols] = useState([
        ...IMPORT_COLUMNS.map((item) => ({
            column: item.key,
            accessor: makeAccessor(item.key, item.accessor),
            minWidth: 150,
            Header: makeHeader(item.label),
            disableFilters: true,
            filter: 'fuzzyText',
        })),
    ]);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [rowsCount, setRowsCount] = useState(0);
    const [filters, setFilters] = useState([]);
    const [controlledPageIndex, setControlledPageIndex] = useState(0);

    const fetchData = useCallback(async ({ pageSize }) => {
        setLoading(true);
        try {
            const res = await getBookkeeperImportHistory();
            const rows = Array.isArray(res?.data) ? res.data.map(parseRow) : [];
            setData(rows);
            setRowsCount(rows.length);
            setPageCount(Math.ceil(rows.length / (pageSize || 50)));
        } catch (err) {
            toast.error('Failed to fetch import history');
        } finally {
            setLoading(false);
        }
    }, []);

    const resetFilters = useCallback(() => setFilters([]), []);

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
                <h2 className="page-title" style={{ margin: 0 }}>Bookkeepers Import History</h2>
            </div>

            <GridElement
                columns={cols}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                controlledPageIndex={controlledPageIndex}
                setControlledPageIndex={setControlledPageIndex}
                filters={filters}
                setFilters={setFilters}
                resetFilters={resetFilters}
                rowsCount={rowsCount}
                hideSelection
                handleRowClick={() => {
                }}
                initialSortBy="import_id"
            />
        </>
    );
};

export default BookkeeperImportHistory;
